// extracted by mini-css-extract-plugin
export var statItem = "_c0-1";
export var statsRow = "_c0-0";